import React from 'react';
import { Input } from 'antd';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

export default class StringEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e) {
        this.props.source.value = e.target.value;
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    render() {

        return (
            <Input className={this.props.source.readOnly ? "input-readonly" : ""} readOnly={this.props.source.readOnly ? true : false} value={this.props.source.value} onChange={e => this.onChange(e)} placeholder={this.props.source.placeholder || ""} />
        );
    }
}

PropertyGridUtils.register("string", (source, propertyGrid) => <StringEditor source={source} propertyGrid={propertyGrid} />);